<div class="sgt-cliente-analise-mercado-rap-form-table" #container>
    <sgt-loading-info
        *ngIf="config?.isLoading"
        title="Carregando Análises de Mercados {{KPI_RAP.sigla}}"
        text="Aguarde um momento enquanto estamos carregando as Análises de Mercados {{KPI_RAP.sigla}}">
    </sgt-loading-info>

    <sgt-cliente-analise-mercado-rap-table
        #table
        [revisaoMode]="revisaoMode"
        [clientes]="dataSub$ | async"
        [total]="searchResponse?.total"
        [legenda]="searchResponse?.legenda"
        [isUltimaPagina]="doneSub$ | async"
        [isEmpty]="searchResponse?.total?.quantidadeClientes == 0"
        (onInfiniteScroll)="onInfiniteScroll()"
        (orderByChange)="onOrderByChange($event)"
        (onChange)="onChange($event)"
        (openAnaliseMercado)="openAnaliseMercado($event)"
        (openCliente)="openCliente($event)"
        (preBaixarCliente)="preBaixarCliente($event)"
        (baixarCliente)="baixarCliente($event)"
        (insertCentralCompra)="insertCentralCompra()"
        (editCentralCompra)="editCentralCompra($event)"
        (insertParticipanteCentralCompra)="insertParticipanteCentralCompra($event)">
    </sgt-cliente-analise-mercado-rap-table>
</div>

<!-- Form de Lançamentos das Análises de Mercado -->
<sgt-cliente-analise-mercado-lancamento-form-modal
    #lancamentoFormModal
    (afterSave)="afterSaveLancamento()">
</sgt-cliente-analise-mercado-lancamento-form-modal>

<!-- Cliente Form Modal -->
<sgt-cliente-form-modal
    #clienteFormModal
    (afterEdit)="afterEditCliente()">
</sgt-cliente-form-modal>

<!-- Modal para pré-baixar um cliente -->
<sgt-cliente-carteira-prebaixar-modal
    #clienteCarteiraPreBaixarModal
    [isRepresentante]="config?.isRepresentante"
    (afterInsertPreBaixa)="afterPreBaixarCliente()"
    (afterEditPreBaixa)="afterPreBaixarCliente()">
</sgt-cliente-carteira-prebaixar-modal>

<!-- Modal para baixar um cliente -->
<sgt-cliente-carteira-baixar-modal
    #clienteCarteiraBaixarModal
    [isRepresentante]="config?.isRepresentante"
    (afterInsertBaixa)="afterBaixarCliente()"
    (afterEditBaixa)="afterBaixarCliente()">
</sgt-cliente-carteira-baixar-modal>

<!-- Cliente Central Compra Form Modal -->
<sgt-cliente-form-modal
    #clienteCentralCompraFormModal
    (afterInsert)="afterInsertCentralCompra($event)">
</sgt-cliente-form-modal>


<!-- Modal para atualiar uma central de compras-->
<sgt-cliente-central-compra-form-modal
    #centralCompraFormModal
    (afterSave)="afterSaveCentralCompra($event)">
</sgt-cliente-central-compra-form-modal>

<!-- Modal para adicionar um participante em uma central de compras -->
<sgt-cliente-central-compra-participante-form-insert-modal
    #centralCompraParticipanteFormModal
    (afterSave)="afterSaveCentralCompra($event)">
</sgt-cliente-central-compra-participante-form-insert-modal>